export function GetConfigSetting(config, name) {
        if(config[name] != null)
            return config[name];

        return config["Environment"].toLowerCase() == "prod" ? config[`${name}Prod`] : config[`${name}Dev`];
}